(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bina-delivery-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bina-delivery-estimate')) {
    customElements.define('bina-delivery-estimate', class extends HTMLElement {
      connectedCallback() {
        this.renderDates();
      }
      addWorkingDays(date, days, includeSaturday, holidays) {
        const next = new Date(date);
        let remaining = days;
        let checked = 0;
        while (remaining > 0 && checked < 730) {
          next.setUTCDate(next.getUTCDate() + 1);
          checked++;
          const weekday = next.getUTCDay();
          if (weekday !== 0 && (includeSaturday || weekday !== 6) && !holidays.has(next.toISOString().slice(0, 10))) remaining--;
        }
        if (remaining) throw new Error('No working date available');
        return next;
      }
      renderDates() {
        try {
          const parts = new Intl.DateTimeFormat('en-CA', { timeZone: this.dataset.timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
          const values = Object.fromEntries(parts.map(part => [part.type, part.value]));
          const today = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
          const days = key => Math.max(0, Math.min(60, Number(this.dataset[key]) || 0));
          const includeSaturday = this.dataset.workingWeek === 'mon_sat';
          const holidays = new Set((this.dataset.holidays || '').split(/[\s,;]+/).filter(value => /^\d{4}-\d{2}-\d{2}$/.test(value)));
          const dispatchStart = this.addWorkingDays(today, days('dispatchMin'), includeSaturday, holidays);
          const dispatchEnd = this.addWorkingDays(today, Math.max(days('dispatchMin'), days('dispatchMax')), includeSaturday, holidays);
          const arrivalStart = this.addWorkingDays(dispatchStart, days('transitMin'), includeSaturday, holidays);
          const arrivalEnd = this.addWorkingDays(dispatchEnd, Math.max(days('transitMin'), days('transitMax')), includeSaturday, holidays);
          const options = { day: 'numeric', month: 'short', timeZone: 'UTC' };
          if (arrivalEnd.getUTCFullYear() !== today.getUTCFullYear()) options.year = 'numeric';
          const format = new Intl.DateTimeFormat(this.dataset.locale || 'en-IN', options);
          const range = (start, end) => start.getTime() === end.getTime() ? format.format(start) : format.formatRange ? format.formatRange(start, end) : format.format(start) + ' – ' + format.format(end);
          this.querySelector('[data-delivery-arrival]').textContent = range(arrivalStart, arrivalEnd);
          this.querySelector('[data-delivery-dispatch]').textContent = range(dispatchStart, dispatchEnd);
        } catch (error) {
          this.removeAttribute('data-dates-ready');
          return;
        }
        this.setAttribute('data-dates-ready', 'true');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bina-handmade-viewer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bina-handmade-viewer')) {
    customElements.define('bina-handmade-viewer', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.querySelector('[data-bina-rotate]')?.addEventListener('click', async () => {
          await customElements.whenDefined('media-gallery');
          if (!this.isConnected) return;
          const gallery = document.getElementById(this.dataset.galleryId);
          gallery?.setActiveMedia(this.dataset.modelId, false);
          const active = gallery?.querySelector('.product__media-item.is-active');
          active?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'nearest' });
          active?.querySelector('model-viewer')?.focus();
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bina-modern-ui"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit',event=>{
    const form=event.target;
    if(!(form instanceof HTMLFormElement)||form.getAttribute('role')!=='search')return;
    const input=form.querySelector('input[name="q"]');if(!input)return;
    event.preventDefault();
    const clean=input.value.replace(/\s*(?:AND )?\(tag:finished-product OR tag:"handmade gifts"\)/gi,'').replace(/\s*-?tag:"handmade gifts"/gi,'').replace(/\s*-?tag:finished-product\b/gi,'').trim();
    const handmade=document.querySelector('#BinaStoreContext')?.dataset.mode==='handmade';
    const url=new URL(form.action,location.origin);
    url.searchParams.set('q',(clean||'*')+(handmade?' tag:"handmade gifts"':' -tag:finished-product -tag:"handmade gifts"'));
    url.searchParams.set('type','product');url.searchParams.set('options[prefix]','last');url.searchParams.set('options[unavailable_products]','last');
    location.assign(url.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bina-stock-filter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
    const toggle=event.target.closest('[data-bina-stock]');
    if(!toggle||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
    event.preventDefault();
    const url=new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.delete('filter.v.availability');
    if(toggle.getAttribute('aria-pressed')!=='true')url.searchParams.set('filter.v.availability',toggle.dataset.binaStock);
    window.location.assign(url.href);
  });
  document.addEventListener('keydown',function(event){
    const toggle=event.target.closest('[data-bina-stock]');
    if(toggle&&event.key===' '){event.preventDefault();toggle.click();}
  });
  } catch(e) { console.error(e); }
})();

})();
